<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" md="4">
            <v-text-field v-model="code" placeholder="Mã hồ sơ" clearable flat outlined dense hide-details />
          </v-col>
          <v-col class="pb-0" cols="12" md="4">
            <v-select
              :items="[
                {t: 'Cơ sở A', v: 'Cơ sở A'},
                {t: 'Cơ sở 1', v: 'Cơ sở 1'},
              ]"
              item-text="t"
              item-value="v"
              v-model="department"
              placeholder="Cơ sở"
              :disabled="disabledDepartmentFilter"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="type"
              :items="[
                {t: 'Khối 6', v: 'Khối 6'},
                {t: 'Khối 10', v: 'Khối 10'},
              ]"
              placeholder="Khối"
              clearable
              flat
              outlined
              dense
              hide-details
              item-text="t"
              item-value="v"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="2">
        <v-btn color="admin" height="40px" width="100%" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row class="my-0">
          <v-col cols="12" md="4">
            <v-text-field
              v-model="parentUsername"
              placeholder="SĐT tài khoản"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="hasEnrollDeadline"
              :items="[
                {t: 'Có hạn riêng', v: 'true'},
                {t: 'Không có hạn riêng', v: 'false'},
              ]"
              placeholder="Hạn đăng ký"
              clearable
              flat
              outlined
              dense
              hide-details
              item-text="t"
              item-value="v"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="enrollmentFlag"
              :items="[
                {t: 'Nhập học', v: 'enroll'},
                {t: 'Dự khuyết', v: 'reserve'},
                {t: 'Đóng', v: 'closed'},
              ]"
              placeholder="T.thái cho phép"
              clearable
              flat
              outlined
              dense
              hide-details
              item-text="t"
              item-value="v"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', ['user']),
  },
  created() {
    if (this.user.department === 'both') {
      this.disabledDepartmentFilter = false
      this.department = ''
    } else this.department = this.user.department
  },
  data() {
    return {
      disabledDepartmentFilter: true,
      //
      code: '',
      department: '',
      parentUsername: '',
      hasEnrollDeadline: '',
      enrollmentFlag: '',
      type: '',
    }
  },
  methods: {
    onFilterChanged() {
      let query = {
        code: this.code.trim(),
        parentUsername: this.parentUsername,
        hasEnrollDeadline: this.hasEnrollDeadline,
        enrollmentFlag: this.enrollmentFlag,
        type: this.type,
      }
      if (!this.department || this.department === 'both') query.department_in = ['unset', 'Cơ sở 1', 'Cơ sở A']
      else query.department_in = ['unset', this.department]
      if (this.registeredAt) query['registeredAt'] = this.registeredAt
      this.$emit('onFilterChanged', query)
    },
  },
}
</script>
